import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty } from 'Utils'

import Collapsible from 'Components/Collapsible'
// import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'

import getAmenities from './components/getAmenities'

import { _SubSectionTitle, _AmenityIconContainer, _ShowMoreCta } from './styles'

class BuildingAmenities extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasHiddenAmenities: true,
      hasHiddenMaintenances: true,
    }
    this.renderAmenities = this.renderAmenities.bind(this)
    this.toggleAmenities = this.toggleAmenities.bind(this)
    this.toggleMaintenances = this.toggleMaintenances.bind(this)
  }

  toggleAmenities() {
    const { hasHiddenAmenities } = this.state
    const { googleAnalyticsEvent, gaSource } = this.props
    this.setState({ hasHiddenAmenities: !hasHiddenAmenities })

    googleAnalyticsEvent({
      category: gaSource,
      action: [
        'Click',
        `${hasHiddenAmenities ? 'Show all' : 'Hide'} amenities from ${
          this.props.isPrecon ? 'precon' : ''
        } building`,
        'click',
      ],
    })
  }

  toggleMaintenances() {
    const { hasHiddenMaintenances } = this.state
    const { googleAnalyticsEvent, gaSource } = this.props
    this.setState({ hasHiddenMaintenances: !hasHiddenMaintenances })

    googleAnalyticsEvent({
      category: gaSource,
      action: [
        'Click',
        `${
          hasHiddenMaintenances ? 'Show all' : 'Hide'
        } included services from ${
          this.props.isPrecon ? 'precon' : ''
        } building`,
        'click',
      ],
    })
  }

  renderAmenities() {
    let collapseBodyChild = null
    const { title, maintenances, amenities, inputId, collapsibleTitle, gaSource } = this.props

    const { hasHiddenAmenities, hasHiddenMaintenances } = this.state

    const amenitiesArr = getAmenities({ amenities, gaSource })
    const included = getAmenities({ amenities: maintenances, gaSource })

    collapseBodyChild = (
      <div>
        {
          !isNilEmpty(amenitiesArr) ? (
            <div>
              <_AmenityIconContainer>
                {hasHiddenAmenities ? amenitiesArr.slice(0, 8) : amenitiesArr}
              </_AmenityIconContainer>
              {
                amenitiesArr.length > 8 &&
                  <_ShowMoreCta
                    onClick={this.toggleAmenities}
                  >
                    {hasHiddenAmenities ? 'Show all' : 'Hide'} amenities
                  </_ShowMoreCta>
              }
            </div>
          ) : ''
        }

        {
          !isNilEmpty(included) ? (
            <Fragment>
              <_SubSectionTitle>
                Included in Maintenance Fees
              </_SubSectionTitle>
              <_AmenityIconContainer>
                {hasHiddenMaintenances ? included.slice(0, 8) : included}
              </_AmenityIconContainer>
              {
                included.length > 8 &&
                  <_ShowMoreCta
                    onClick={this.toggleMaintenances}
                  >
                    {hasHiddenMaintenances ? 'Show all' : 'Hide'} included services
                  </_ShowMoreCta>
              }
            </Fragment>
          ) : ''
        }

      </div>
    )
    if(collapseBodyChild) {
      return (
        <Collapsible
          inputId={inputId}
          title={collapsibleTitle}
          showSeparatorLine
          seoText={
            `View available facilities at ${title}`
          }
          defaultShowState
        >
          {collapseBodyChild}
        </Collapsible>
      )
    }
  }
  render() {
    return (
      this.renderAmenities()
    )
  }
}

BuildingAmenities.propTypes = {
  googleAnalyticsEvent: PropTypes.func,
  title: PropTypes.string,
  maintenances: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    icon_name: PropTypes.string,
  })),
  amenities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    icon_name: PropTypes.string,
  })),
  collapsibleTitle: PropTypes.string,
  inputId: PropTypes.string,
  gaSource: PropTypes.string,
  isPrecon: PropTypes.bool,
}

export default BuildingAmenities
